var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33203 9.91666V11.0833C2.33203 11.3927 2.45495 11.6895 2.67374 11.9083C2.89253 12.1271 3.18928 12.25 3.4987 12.25H10.4987C10.8081 12.25 11.1049 12.1271 11.3237 11.9083C11.5424 11.6895 11.6654 11.3927 11.6654 11.0833V9.91666M4.08203 6.41666L6.9987 9.33333M6.9987 9.33333L9.91536 6.41666M6.9987 9.33333V2.33333",
    stroke: "#5441D8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.71f9f9eaf50a185390cd3613078e1a4c.svg";
export { ForwardRef as ReactComponent };